import { Meta } from "../partials/meta";
import decodeHtml from "../helpers/decode";

// Project Styles
import '../styles/components/clients.scss';

interface ClientType {
    client_id: string;
    client_name: string;
}

interface ClientsType {
    clients: ClientType[];
}

const Clients = ({clients} : ClientsType) => {
    return (
        <>
            <h1>Clients</h1>
            <div className="client-list">
                <Meta title="Clients" description="A List of Clients"/>
                {clients.map((client: ClientType) => (
                    <div className="client-card" key={client.client_id}>
                        <h5>{decodeHtml(client.client_name)}</h5>
                    </div>
                ))}
            </div>
        </>
    );
}

export default Clients;